import React from 'react';

export const NotFound = () => {
  return (
    <div>
      <h1>NotFound</h1>
      <p className='lead'>The Page you are looking for does not exits</p>
    </div>
  );
};
